var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_1832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 0H3.75002C1.68749 0 0 1.68749 0 3.75002V20.25C0 22.3125 1.68749 24 3.75002 24H20.25C22.3125 24 24 22.3125 24 20.25V3.75002C24 1.68749 22.3125 0 20.25 0ZM22.5 20.25C22.5 21.4907 21.4907 22.5 20.25 22.5H3.75002C2.50932 22.5 1.5 21.4907 1.5 20.25V3.75002C1.5 2.50937 2.50932 1.5 3.75002 1.5H20.25C21.4907 1.5 22.5 2.50937 22.5 3.75002V20.25H22.5Z",
    fill: "#696969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61768 11.8313C6.61768 8.85888 9.02734 6.44922 11.9998 6.44922C14.9723 6.44922 17.3819 8.85888 17.3819 11.8313V12.1714C17.3819 15.1439 14.9723 17.5536 11.9998 17.5536C9.02734 17.5536 6.61768 15.1439 6.61768 12.1714V11.8313Z",
    fill: "#696969"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_1832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareIcon);
export default __webpack_public_path__ + "static/media/square_icon.1863803d8a07f1d568278f2d0fa9b180.svg";
export { ForwardRef as ReactComponent };